import React from 'react';

import CreditCards from '../../../../images/CreditCards';
import Debt from '../../../../images/Debt';
import EarnMoneyIcon from '../../../../images/EarnMoney';
import Insurance from '../../../../images/Insurance';
import Investment from '../../../../images/Investment';
import Loans from '../../../../images/Loans';
import Retirement from '../../../../images/Retirement';
import SaveMoney from '../../../../images/SaveMoney';
import Taxes from '../../../../images/Taxes';

import style from './Hero.scss';

export const list = [
  {
    href: '/extra-money/',
    icon: <EarnMoneyIcon />,
    title: 'Earn Money',
    target: undefined,
  },
  {
    href: 'https://www.jdoqocy.com/click-100896267-15232132',
    icon: <SaveMoney />,
    title: 'Save Money',
    target: '_blank',
  },
  {
    href: 'https://debt-busters.sjv.io/vNOnxj',
    icon: <Debt />,
    title: 'Debt',
    target: '_blank',
  },
  {
    href: 'https://acorns.sjv.io/9gxeG0',
    icon: <Retirement />,
    title: 'Retirement',
    target: '_blank',
  },
  {
    href: '/personal-loans/',
    icon: <Loans />,
    title: 'Loans',
    target: undefined,
  },
  {
    icon: <CreditCards />,
    title: 'Credit Cards',
    target: '_blank',
    subLinks: [
      {
        href: 'https://www.cardratings.com/bestcards?src=690378',
        title: 'Good Credit',
        target: '_blank',
      },
      {
        href: '/credit-cards/',
        title: 'Bad Credit',
        target: undefined,
      },
    ],
  },
  {
    href: 'https://www.sahg6dtr.com/2WBM5TS/R74QP',
    icon: <Investment />,
    title: 'Investment',
    target: '_blank',
  },
  {
    href: 'http://avvocauto.com/form/?c=20721',
    icon: <Insurance />,
    title: 'Insurance',
    target: '_blank',
  },
  {
    href: 'https://linkto.hrblock.com/4eeJD3',
    icon: <Taxes />,
    title: 'Taxes',
    target: '_blank',
  },
];

const HeroA = () => {
  return (
    <section className={style.hero}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>
              Navigate life on your terms
              <small>Compare rates and get expert guidance on all things finance</small>
            </h1>
            <div className={style.items}>
              {list.map((item) => (
                <a key={item.href} href={item.href} target={item.target}>
                  {item.icon}
                  <h4>{item.title}</h4>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroA;
